import { Trophy, XCircle, Medal, ChartLine } from "@phosphor-icons/react";

function StatBox({ label, value, sub, color, icon: Icon }) {
  return (
    <div className="border border-border p-4 bg-white">
      <div className="flex items-center gap-2 mb-2">
        <Icon weight="bold" size={14} className="text-zinc-400" />
        <span className="mono-label text-zinc-400">{label}</span>
      </div>
      <p className={`font-mono text-2xl font-bold ${color}`}>{value}</p>
      {sub && <p className="font-mono text-xs text-zinc-400 mt-1">{sub}</p>}
    </div>
  );
}

export default function WinLossStats({ stats }) {
  if (!stats) return null;

  return (
    <div data-testid="win-loss-stats" className="grid grid-cols-2 lg:grid-cols-4 gap-2">
      <StatBox
        label="Wins"
        value={stats.wins}
        sub={`${stats.win_rate}% strike rate`}
        color="text-[#008A27]"
        icon={Trophy}
      />
      <StatBox
        label="Places"
        value={stats.places}
        sub={`${stats.place_rate}% place rate`}
        color="text-zinc-900"
        icon={Medal}
      />
      <StatBox
        label="Losses"
        value={stats.losses}
        color="text-[#E12B00]"
        icon={XCircle}
      />
      <StatBox
        label="Total Races"
        value={stats.total_races}
        sub="last 20 shown"
        color="text-zinc-900"
        icon={ChartLine}
      />
    </div>
  );
}
